import dayjs from 'dayjs'

export const generateSlots = (from, to) => {
  let slots = []
  for (let i = parseInt(from); i < parseInt(to); i++) {
    slots.push(`${i + ':00'}-${i + 1 + ':00'}`)
  }
  return slots
}

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const isUsernameValid = (username) => {
  const regex = new RegExp(/^[a-z0-9_-]+$/)
  return regex.test(username)
}

export async function validateCaptcha(captchaCode) {
  // Bypass reCAPTCHA in dev/staging environments
  if (process.env.NEXT_PUBLIC_DISABLE_RECAPTCHA === 'true') {
    return { status: 'success', success: true, message: 'reCAPTCHA bypassed (dev mode)' }
  }

  try {
    const response = await fetch('/api/gRecaptcha', {
      method: 'POST',
      body: JSON.stringify({
        gRecaptchaToken: captchaCode,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    const data = await response.json()
    return data
  } catch (err) {
    console.error('validateCaptcha response::', err)
  }
}

export function isOverdue(date, unit = 'h') {
  // Note: if its retrun positive value then is overdue
  const diff = dayjs().diff(date, unit)
  const result = diff > 0 ? true : false
  return { result, diff }
}

export function formatJobDate(date, hour = 0, minute = 0) {
  return new Date(
    dayjs(date)
      .set('hour', parseInt(hour))
      .set('minute', parseInt(minute))
      .toDate(),
  )
}

export function formatJobStatus(status) {
  switch (status) {
    case 'cancel':
      return (
        <div className="px-3 py-1 rounded-2xl gap-1 flex items-center capitalize bg-[#FEF3F2]">
          <div className="h-[6px] w-[6px] rounded-[50%] bg-[#B42318]" />
          <p className="text-[#B42318] text-xs">cancelled</p>
        </div>
      )
    case 'completed':
      return (
        <div className="px-3 py-1 rounded-2xl gap-1 flex items-center capitalize bg-[#EEF4FF]">
          <div className="h-[6px] w-[6px] rounded-[50%] bg-[#444CE7]" />
          <p className="text-[#444CE7] text-xs">Completed</p>
        </div>
      )
    case 'overdue':
      return (
        <div className="px-3 py-1 rounded-2xl gap-1 flex items-center capitalize bg-[#FFFAEB]">
          <div className="h-[6px] w-[6px] rounded-[50%] bg-corange-450" />
          <p className="text-corange-500 text-xs">Overdue</p>
        </div>
      )
    case 'upcoming':
      return (
        <div className="px-3 py-1 rounded-2xl gap-1 flex items-center capitalize bg-[#ECFDF3]">
          <div className="h-[6px] w-[6px] rounded-[50%] bg-[#027A48]" />
          <p className="text-[#027A48] text-xs">Upcoming</p>
        </div>
      )
  }
}

export const formatForSelect = (select) => {
  if (select?.value) return select
  return { value: select, label: select }
}

export const generatePassword = (length = 16) => {
  let generatedPassword = ''
  const validChars =
    '0123456789' +
    'abcdefghijklmnopqrstuvwxyz' +
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
    '_'
  // ',.-{}+!"#$%/()=?'

  for (let i = 0; i < length; i++) {
    let randomNumber = crypto.getRandomValues(new Uint32Array(1))[0]
    randomNumber = randomNumber / 0x100000000
    randomNumber = Math.floor(randomNumber * validChars.length)

    generatedPassword += validChars[randomNumber]
  }

  return generatedPassword
}
